import React, { forwardRef } from 'react';
import Text from '@polestar/component-warehouse-react/components/text/Text';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
const Label = forwardRef((props, ref) => {
    return React.createElement(Container, { ref: ref, as: "label", ...props });
});
Label.displayName = 'Label';
export default Label;
const Container = styled(Text)(({ theme }) => css `
    color: ${theme.label.color};
  `);
